import { render, staticRenderFns } from "./slider-galeria.vue?vue&type=template&id=eb6ad236&scoped=true&"
import script from "./slider-galeria.vue?vue&type=script&lang=js&"
export * from "./slider-galeria.vue?vue&type=script&lang=js&"
import style0 from "./slider-galeria.vue?vue&type=style&index=0&id=eb6ad236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6ad236",
  null
  
)

export default component.exports